import { render, staticRenderFns } from "./lawsStatute.vue?vue&type=template&id=4a1e6a30&scoped=true"
import script from "./lawsStatute.vue?vue&type=script&lang=js"
export * from "./lawsStatute.vue?vue&type=script&lang=js"
import style0 from "./lawsStatute.vue?vue&type=style&index=0&id=4a1e6a30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1e6a30",
  null
  
)

export default component.exports